export default {
  SET_START_AT(state, startAt) {
    state.startAt = startAt;
  },

  SET_JIRA_RESULTS(state, jiraResults) {
    state.jiraResults = jiraResults;
  },

  SET_CONFLUENCE_RESULTS(state, confluenceResults) {
    state.confluenceResults = confluenceResults;
  },

  SET_CONFLUENCE_OPENED_INDEX(state, confluenceOpenedIndex) {
    state.confluenceOpenedIndex = confluenceOpenedIndex;
  },

  SET_COMMENT_OPENED_INDEX(state, commentOpenedIndex) {
    state.commentOpenedIndex = commentOpenedIndex;
  },

  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },

  SET_CONFLUENCE_PAGE_INCREMENT(state, confluencePageIncrement) {
    state.confluencePageIncrement = confluencePageIncrement;
  },

  SET_JIRA_PAGE_INCREMENT(state, jiraIncrementPage) {
    state.jiraIncrementPage = jiraIncrementPage;
  },

  SET_TRANSITION(state, transition) {
    state.transition = transition;
  },

  SET_SHOW_ANNOUNCEMENT(state, showAnnouncement) {
    state.showAnnouncement = showAnnouncement;
  },

  SET_LOADER(state, loader) {
    state.loader = loader;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js